import React, { useEffect } from 'react'
import LoginTo from './auth/LoginTo'

const AuthLayout = () => {
  useEffect(() => {
    // Add CSS files
    const addStylesheet = (href) => {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = href
      document.head.appendChild(link)
    }

    // Add JS files
    const addScript = (src) => {
      const script = document.createElement('script')
      script.src = src
      script.async = true
      document.body.appendChild(script)
    }

    addStylesheet(`${process.env.PUBLIC_URL}/admin_assets/css/bootstrap.min.css`)
    addStylesheet(`${process.env.PUBLIC_URL}/admin_assets/css/app.min.css`)
    addStylesheet(`${process.env.PUBLIC_URL}/admin_assets/css/style.css`)
    addStylesheet(`${process.env.PUBLIC_URL}/admin_assets/css/components.css`)
    addStylesheet(`${process.env.PUBLIC_URL}/admin_assets/css/custom.css`)

    addScript(`${process.env.PUBLIC_URL}/admin_assets/js/app.min.js`)
    addScript(`${process.env.PUBLIC_URL}/admin_assets/js/bootstrap.min.js`)
    addScript(`${process.env.PUBLIC_URL}/admin_assets/js/page/index.js`)
    addScript(`${process.env.PUBLIC_URL}/admin_assets/js/scripts.js`)
    addScript(`${process.env.PUBLIC_URL}/admin_assets/js/custom.js`)
    addScript(`${process.env.PUBLIC_URL}/admin_assets/bundles/apexcharts/apexcharts.min.js`)

    return () => {
      // Cleanup stylesheets
      document.head.querySelectorAll('link').forEach(link => {
        if (link.href.includes('/assets/css/')) {
          document.head.removeChild(link)
        }
      })

      // Cleanup scripts
      document.body.querySelectorAll('script').forEach(script => {
        if (script.src.includes('/assets/js/')) {
          document.body.removeChild(script)
        }
      })
    }
  }, [])

  return (
    <div>
      <div className="">
          <LoginTo/>
      </div>
    </div>
  )
}

export default AuthLayout
